var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "audio",
    d: "M19.637 10.485a7.572 7.572 0 0 0-3.79-5.652 7.795 7.795 0 0 0-7.693 0 7.572 7.572 0 0 0-3.79 5.652h1.482c.51 0 .923.407.923.909v9.697c0 .502-.413.909-.923.909H3.385C1.555 22 0 20.774 0 19.152v-5.819c0-1.351 1.08-2.428 2.497-2.75.267-3.039 2.022-5.782 4.734-7.324a9.666 9.666 0 0 1 9.538 0c2.712 1.542 4.467 4.285 4.734 7.325 1.418.321 2.497 1.398 2.497 2.75v5.818C24 20.774 22.444 22 20.615 22h-2.461a.916.916 0 0 1-.923-.91v-9.696c0-.502.413-.91.923-.91h1.483zm-.56 9.697h1.538c.889 0 1.539-.512 1.539-1.03v-5.819c0-.518-.65-1.03-1.539-1.03h-1.538v7.879zm-14.154 0v-7.879H3.385c-.889 0-1.539.512-1.539 1.03v5.819c0 .518.65 1.03 1.539 1.03h1.538z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "audiob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#audio"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#929292",
    xlinkHref: "#audio"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#audiob)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.734a12fa.svg";
export { ForwardRef as ReactComponent };